import axios from '@/utils/api'

const actions = {
  async findByFilter ({ commit }, filter) {
    return axios({
      url: `certificado/filter`,
      method: 'POST',
      data: filter
    })
  },

  async getDocumentoViewByIdProcesso ({ commit }, idProcesso) {
    return axios({
      url: `certificado/documento/view/processo/${idProcesso}`,
      method: 'GET'
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/certificado.js